/**
 * Theme Types & Constants (CAND-14: Dark / Light Theme Toggle)
 */

export type ThemePreference = 'light' | 'dark' | 'system';
export type ResolvedTheme = 'light' | 'dark';

export interface ThemeState {
  theme: ThemePreference;
  resolvedTheme: ResolvedTheme;
}

export const THEME_STORAGE_KEY = 'mm_theme_pref';
